import React, { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import Button from "components/Button";
import { Modal } from "react-bootstrap";

pdfjs.GlobalWorkerOptions.workerSrc = "/pdf.worker.min.mjs";

interface PdfViewerProps {
  documentUrl?: string;
  height?: number;
  width?: number;
  onClose?: () => void;
}

function PdfViewer({
  documentUrl,
  height = 400,
  width = 400,
  onClose,
}: PdfViewerProps) {
  const [numPages, setNumPages] = useState<number | null>(null);
  const [pageNumber, setPageNumber] = useState(1);

  function onDocumentLoadSuccess({ numPages }: { numPages: number }) {
    setNumPages(numPages);
  }

  return (
    <Modal show={true} onClose={onClose} onHide={onClose}>
      <Modal.Header closeButton />
      <Modal.Body>
        <div className="pdf-viewer-container">
          <Document file={documentUrl} onLoadSuccess={onDocumentLoadSuccess}>
            <Page
              pageNumber={pageNumber}
              height={height}
              width={width}
              renderAnnotationLayer={false}
            />
          </Document>
          <p>
            Page {pageNumber} of {numPages}
          </p>
          <div className="btn-row">
            <Button
              onClick={() => setPageNumber(pageNumber - 1)}
              size="sm"
              name="action"
              btnLabel="Prev Page"
              disabled={pageNumber === 1}
            />
            <Button
              onClick={() => setPageNumber(pageNumber + 1)}
              size="sm"
              name="action"
              btnLabel="Next Page"
              disabled={pageNumber === numPages}
            />
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default PdfViewer;
